// ST1 Sports — Drawer Accordion (v11 — mobile L1 drill-down)
// Desktop: .toggle-drawer-menu .drawer-menu__sub-panel (CSS max-height accordion)
//          initDesktopPanel() adds L2/L3 click-expand within each sport sub-panel
// Mobile:  injects "Shop by Sport" 3-level accordion into main-nav-mobile

(function () {
  'use strict';

  function sp(el, prop, val) { el.style.setProperty(prop, val, 'important'); }

  function stripPrefix(text) {
    var idx = text.indexOf(' – ');
    if (idx !== -1) return text.slice(idx + 3).trim();
    var parts = text.split(' - ');
    if (parts.length > 1) return parts[parts.length - 1].trim();
    return text;
  }

  // ── DESKTOP ──────────────────────────────────────────────────────────────
  // Adds click-expand accordion within each sport's sub-panel (L2 → L3)
  function initDesktopPanel(panel) {
    if (panel.dataset.st1Init) return;

    var hdrItems = Array.from(panel.querySelectorAll('li.mega-menu__item')).filter(function (li) {
      return !li.classList.contains('drawer-menu-item');
    });
    if (!hdrItems.length) return;
    panel.dataset.st1Init = '1';

    var lv1 = panel.closest('.drawer-menu-lv1');
    if (lv1 && !lv1.dataset.st1HoverFixed) {
      lv1.dataset.st1HoverFixed = '1';
      ['mouseenter', 'mouseleave'].forEach(function (evt) {
        lv1.addEventListener(evt, function (e) { e.stopImmediatePropagation(); }, true);
      });
    }

    hdrItems.forEach(function (li) {
      var hdrP  = li.querySelector('p.drawer-menu-item-lv-2');
      var hdrA  = hdrP && hdrP.querySelector('a');
      var subUl = li.querySelector('ul.last-level-menu');
      if (!hdrP || !hdrA) return;

      li.classList.add('st1-l2-hdr');
      hdrA.classList.remove('link-animation');

      sp(hdrP, 'display', 'flex'); sp(hdrP, 'align-items', 'center');
      sp(hdrP, 'width', '100%'); sp(hdrP, 'box-sizing', 'border-box');
      sp(hdrP, 'padding', '11px 16px'); sp(hdrP, 'margin', '0');
      sp(hdrP, 'background', '#f2f2f2'); sp(hdrP, 'border-bottom', '1px solid #ddd');
      sp(hdrP, 'cursor', subUl ? 'pointer' : 'default');

      sp(hdrA, 'flex', '1'); sp(hdrA, 'display', 'block');
      sp(hdrA, 'color', '#333'); sp(hdrA, 'font-size', '0.88rem');
      sp(hdrA, 'font-weight', '600'); sp(hdrA, 'text-decoration', 'none');
      sp(hdrA, 'background', 'transparent');

      if (!subUl) return;

      sp(subUl, 'display', 'none'); sp(subUl, 'margin', '0'); sp(subUl, 'padding', '0');

      Array.from(subUl.querySelectorAll('li a')).forEach(function (a) {
        var s = stripPrefix(a.textContent.trim());
        if (s !== a.textContent.trim()) a.textContent = s;
        sp(a, 'display', 'block'); sp(a, 'width', '100%');
        sp(a, 'box-sizing', 'border-box'); sp(a, 'padding', '8px 16px 8px 36px');
        sp(a, 'font-size', '0.83rem'); sp(a, 'color', '#555');
        sp(a, 'background', '#fafafa'); sp(a, 'border-bottom', '1px solid #ebebeb');
        sp(a, 'text-decoration', 'none');
        a.addEventListener('mouseenter', function () { sp(a, 'color', '#F37321'); sp(a, 'background', '#fff5ee'); });
        a.addEventListener('mouseleave', function () { sp(a, 'color', '#555');    sp(a, 'background', '#fafafa'); });
      });

      var chev = document.createElement('span');
      chev.textContent = '›';
      sp(chev, 'font-size', '1.1rem'); sp(chev, 'color', '#999');
      sp(chev, 'display', 'inline-block'); sp(chev, 'transition', 'transform 0.2s');
      sp(chev, 'flex-shrink', '0'); sp(chev, 'margin-left', '4px');
      hdrP.appendChild(chev);

      var open = false;
      hdrP.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        open = !open;
        sp(subUl, 'display', open ? 'block' : 'none');
        chev.style.setProperty('transform', open ? 'rotate(90deg)' : 'rotate(0deg)', 'important');
      });
      hdrP.addEventListener('mouseenter', function () { sp(hdrP, 'background', '#e8e8e8'); });
      hdrP.addEventListener('mouseleave', function () { sp(hdrP, 'background', '#f2f2f2'); });
    });
  }

  // ── MOBILE SPORT NAV ─────────────────────────────────────────────────────
  // /collections.json is Shopify's public AJAX endpoint — returns ALL collections
  // with their real titles, no auth required. Paginate to get past 250.
  var _collectionMap = null; // { '/collections/handle': 'Real Title' }
  function getCollectionMap(cb) {
    if (_collectionMap) { cb(_collectionMap); return; }
    var acc = {};
    function fetchPage(page) {
      fetch('/collections.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = data.collections || [];
          list.forEach(function (c) { acc['/collections/' + c.handle] = c.title; });
          if (list.length === 250) {
            fetchPage(page + 1);
          } else {
            _collectionMap = acc;
            cb(acc);
          }
        })
        .catch(function () { _collectionMap = acc; cb(acc); });
    }
    fetchPage(1);
  }
  function initMobileNav() {
    return st1BuildMobileNavFromMenu();
    if (window.innerWidth >= 1024) return;
    if (document.getElementById('st1-mobile-sport')) return; // already done

    var mobileNavContent =
      document.querySelector('.main-nav-mobile .scrollbar-body') ||
      document.querySelector('.main-nav-mobile .overflow-y-auto') ||
      document.querySelector('nav.main-nav-mobile');
    if (!mobileNavContent) return;

    var sportLis = Array.from(document.querySelectorAll('.toggle-drawer-menu > ul > li.drawer-menu-lv1'));
    if (!sportLis.length) {
      var ST1_SPORTS = [
        ['Baseball', '/collections/baseball'],
        ['Softball', '/collections/softball'],
        ['Basketball', '/collections/basketball'],
        ['Football', '/collections/football'],
        ['Lacrosse', '/collections/lacrosse'],
        ['Racket Sports', '/collections/racket-sports'],
        ['Soccer', '/collections/soccer'],
        ['Track & Field', '/collections/track-field'],
        ['Volleyball', '/collections/volleyball'],
        ['Wrestling', '/collections/wrestling'],
        ['Other Sports', '/collections/other-sports']
      ];
      sportLis = ST1_SPORTS.map(function (s) {
        var li = document.createElement('li');
        li.className = 'drawer-menu-lv1';
        var a = document.createElement('a');
        a.href = s[1]; a.textContent = s[0];
        li.appendChild(a);
        return li;
      });
    }

    // ── Outer wrapper ──
    var wrapper = document.createElement('div');
    wrapper.id = 'st1-mobile-sport';
    wrapper.style.borderBottom = '1px solid #e5e7eb';

    // ── "Shop by Sport" top row (always visible, toggles sport list) ──
    var topRow = document.createElement('div');
    topRow.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:16px 10px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';

    var topLabel = document.createElement('span');
    topLabel.textContent = 'Shop by Sport';
    topLabel.style.cssText = 'font-size:1rem;font-weight:700;color:#424242;font-family:Lexend,sans-serif;';

    var topChev = document.createElement('span');
    topChev.textContent = '›';
    topChev.style.cssText = 'font-size:1.3rem;color:#F37321;display:inline-block;transition:transform 0.25s;';

    topRow.appendChild(topLabel); topRow.appendChild(topChev);
    wrapper.appendChild(topRow);

    // ── Sport list (hidden by default, toggled by topRow) ──
    var sportList = document.createElement('div');
    sportList.style.cssText = 'display:none;background:#f9f9f9;';

    topRow.addEventListener('click', function () {
      var open = sportList.style.display === 'none';
      sportList.style.display = open ? 'block' : 'none';
      topChev.style.transform = open ? 'rotate(90deg)' : 'none';
    });

    // ── Back row (only visible when drilled into a sport) ──
    var backRow = document.createElement('div');
    backRow.style.cssText = 'display:none;align-items:center;padding:14px 10px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
    var backLabel = document.createElement('span');
    backLabel.style.cssText = 'font-size:0.95rem;font-weight:700;color:#F37321;font-family:Lexend,sans-serif;';
    backRow.appendChild(backLabel);
    sportList.appendChild(backRow);

    // refs for drill-down show/hide
    var allSportRows = [];
    var allCatLists = [];

    function showSportLevel() {
      topRow.style.display = '';
      backRow.style.display = 'none';
      allSportRows.forEach(function (r) { r.style.display = 'flex'; });
      allCatLists.forEach(function (c) { c.style.display = 'none'; });
    }
    function drillIntoSport(catList, name) {
      topRow.style.display = 'none';
      backLabel.textContent = '‹  ' + name;
      backRow.style.display = 'flex';
      allSportRows.forEach(function (r) { r.style.display = 'none'; });
      allCatLists.forEach(function (c) { c.style.display = (c === catList) ? 'block' : 'none'; });
    }
    backRow.addEventListener('click', showSportLevel);

    // Build sport rows first, collecting catList refs for sequential panel reading
    var sportRows = [];
    sportLis.forEach(function (sportLi, idx) {
      var sportAnchor = sportLi.querySelector('a');
      var sportName = sportAnchor ? sportAnchor.textContent.trim() : '';
      if (!sportName) { sportRows.push(null); return; }

      var sportRow = document.createElement('div');
      sportRow.style.cssText = 'display:flex;align-items:center;padding:12px 10px 12px 20px;background:#f2f2f2;border-bottom:1px solid #e5e7eb;cursor:pointer;';

      var sportLabel = document.createElement('span');
      sportLabel.textContent = sportName;
      sportLabel.style.cssText = 'flex:1;color:#333;font-size:0.92rem;font-weight:600;font-family:Lexend,sans-serif;';
      sportRow.appendChild(sportLabel);

      var sportChev = document.createElement('span');
      sportChev.textContent = '›';
      sportChev.style.cssText = 'font-size:1rem;color:#999;display:inline-block;flex-shrink:0;margin-left:8px;';
      sportRow.appendChild(sportChev);

      sportList.appendChild(sportRow);

      var catList = document.createElement('div');
      catList.style.cssText = 'display:none;background:#fff;';
      sportList.appendChild(catList);

      allSportRows.push(sportRow);
      allCatLists.push(catList);

      // Level 1 = drill down: hide other sports + header, show only this sport's subs
      sportRow.addEventListener('click', function () {
        drillIntoSport(catList, sportName);
      });

      sportRows.push({ li: sportLi, anchor: sportAnchor, name: sportName, catList: catList, panelIdx: idx });
    });

    wrapper.appendChild(sportList);
    mobileNavContent.insertBefore(wrapper, mobileNavContent.firstChild);

    // ── Static main-menu items below sport accordion ──
    var NAV_ITEMS = [
      { title: 'Apparel', url: '/collections/apparel', children: [
        { title: 'All Apparel',  url: '/collections/apparel' },
        { title: "Men's",        url: '/collections/apparel-mens' },
        { title: "Women's",      url: '/collections/apparel-womens' },
        { title: 'Youth',        url: '/collections/apparel-youth' },
        { title: 'Headwear',     url: '/collections/apparel-headwear' }
      ]},
      { title: 'Footwear', url: '/collections/footwear', children: [
        { title: 'All Footwear', url: '/collections/footwear' },
        { title: 'Baseball',     url: '/collections/footwear-baseball' },
        { title: 'Softball',     url: '/collections/footwear-softball' },
        { title: 'Volleyball',   url: '/collections/footwear-volleyball' },
        { title: 'Running',      url: '/collections/footwear-running' },
        { title: 'Training',     url: '/collections/footwear-training' },
        { title: 'Lifestyle',    url: '/collections/footwear-lifestyle' }
      ]},
      { title: 'Eyewear', url: '/collections/eyewear', children: [
        { title: 'All Eyewear',          url: '/collections/eyewear' },
        { title: 'Baseball & Softball',  url: '/collections/eyewear-baseball-softball' },
        { title: 'Lifestyle',            url: '/collections/eyewear-lifestyle' },
        { title: 'Running & Cycling',    url: '/collections/eyewear-running-cycling' },
        { title: 'Snow Sports',          url: '/collections/eyewear-snow-sports' }
      ]},
      { title: 'Sale',              url: '/collections/sale',           children: [] },
      { title: 'Team Gear',         url: '/pages/team-gear',            children: [] },
      { title: 'Custom Team Store', url: '/pages/custom-team-store',    children: [] }
    ];

    var navSection = document.createElement('div');
    navSection.id = 'st1-mobile-nav';

    NAV_ITEMS.forEach(function (item) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:14px 10px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
      var lbl = document.createElement('span');
      lbl.textContent = item.title;
      lbl.style.cssText = 'font-size:1rem;font-weight:700;color:#424242;font-family:Lexend,sans-serif;';
      row.appendChild(lbl);
      var chev = document.createElement('span');
      chev.style.cssText = 'font-size:1.3rem;color:#F37321;display:inline-block;transition:transform 0.25s;';
      row.appendChild(chev);
      navSection.appendChild(row);

      if (item.children.length) {
        chev.textContent = '›';
        var sub = document.createElement('div');
        sub.style.cssText = 'display:none;background:#f9f9f9;';
        item.children.forEach(function (child) {
          var a = document.createElement('a');
          a.href = child.url;
          a.textContent = child.title;
          a.style.cssText = 'display:block;padding:12px 10px 12px 24px;color:#424242;font-size:0.9rem;font-weight:500;font-family:Lexend,sans-serif;text-decoration:none;border-bottom:1px solid #e5e7eb;background:#fff;';
          sub.appendChild(a);
        });
        navSection.appendChild(sub);
        row.addEventListener('click', function () {
          var open = sub.style.display === 'none';
          sub.style.display = open ? 'block' : 'none';
          chev.style.transform = open ? 'rotate(90deg)' : 'none';
        });
      } else {
        row.addEventListener('click', function () { window.location.href = item.url; });
      }
    });

    wrapper.insertAdjacentElement('afterend', navSection);

    // Hierarchy via title patterns (handles are inconsistent; titles are not).
    // L2 title: "{Sport} – {Name}"          e.g. "Baseball – Apparel"
    // L3 title: "{Sport} {Abbrev} – {Name}" e.g. "Baseball Catchers – Helmets & Masks"
    // L3 parent matched by finding the L2 whose shortName starts with the L3 abbreviation.
    getCollectionMap(function (map) {
      sportRows.forEach(function (row) {
        if (!row) return;
        var sport = row.name; // e.g. "Baseball"
        var EM = ' – '; // " – "
        var l2Pre = sport + EM;  // "Baseball – "

        var l2Items = [];   // {path, shortName}
        var pendingL3 = []; // {path, abbrev, display}

        Object.keys(map).forEach(function (path) {
          var t = map[path];
          if (t.indexOf(sport) !== 0) return; // must start with sport name

          if (t.indexOf(l2Pre) === 0) {
            // L2: "Baseball – Apparel"
            l2Items.push({ path: path, shortName: t.slice(l2Pre.length) });
          } else if (t.indexOf(sport + ' ') === 0) {
            // L3: "Baseball Catchers – Helmets & Masks"
            var rest = t.slice(sport.length + 1); // "Catchers – Helmets & Masks"
            var di = rest.indexOf(EM);
            if (di !== -1) {
              pendingL3.push({
                path: path,
                abbrev: rest.slice(0, di),           // "Catchers"
                display: rest.slice(di + EM.length)  // "Helmets & Masks"
              });
            }
          }
        });

        if (!l2Items.length) return;

        // Assign L3 to L2 parent: L2 whose shortName starts with L3 abbreviation
        var l3ByParent = {};
        pendingL3.forEach(function (l3) {
          var parentPath = null;
          l2Items.forEach(function (l2) {
            if (l2.shortName.toLowerCase().indexOf(l3.abbrev.toLowerCase()) === 0) {
              parentPath = l2.path;
            }
          });
          if (parentPath) {
            if (!l3ByParent[parentPath]) l3ByParent[parentPath] = [];
            l3ByParent[parentPath].push({ path: l3.path, title: l3.display });
          }
        });

        l2Items.sort(function (a, b) { return a.shortName < b.shortName ? -1 : 1; });
        row.catList.dataset.built = '1';

        l2Items.forEach(function (l2) {
          var children = (l3ByParent[l2.path] || []).sort(function (a, b) { return a.title < b.title ? -1 : 1; });

          var l2Row = document.createElement('div');
          l2Row.style.cssText = 'display:flex;align-items:center;padding:10px 10px 10px 28px;background:#f5f5f5;border-bottom:1px solid #e5e7eb;cursor:pointer;';
          var l2Label = document.createElement('span');
          l2Label.textContent = l2.shortName;
          l2Label.style.cssText = 'flex:1;color:#333;font-size:0.88rem;font-weight:500;font-family:Lexend,sans-serif;';
          l2Row.appendChild(l2Label);
          var l2Chev = document.createElement('span');
          l2Chev.textContent = '›';
          l2Chev.style.cssText = 'font-size:0.9rem;color:#999;display:inline-block;transition:transform 0.2s;flex-shrink:0;margin-left:6px;';
          l2Row.appendChild(l2Chev);
          row.catList.appendChild(l2Row);

          if (children.length) {
            var l3List = document.createElement('div');
            l3List.style.cssText = 'display:none;background:#fafafa;';
            children.forEach(function (l3) {
              var a = document.createElement('a');
              a.href = l3.path;
              a.textContent = l3.title;
              a.style.cssText = 'display:block;padding:9px 10px 9px 44px;color:#555;font-size:0.83rem;font-family:Lexend,sans-serif;text-decoration:none;border-bottom:1px solid #f0f0f0;';
              l3List.appendChild(a);
            });
            row.catList.appendChild(l3List);
            l2Row.addEventListener('click', function (e) {
              e.stopPropagation();
              var open = l3List.style.display === 'none';
              l3List.style.display = open ? 'block' : 'none';
              l2Chev.style.transform = open ? 'rotate(90deg)' : 'none';
              l2Row.style.background = open ? '#ececec' : '#f5f5f5';
            });
          } else {
            l2Row.addEventListener('click', function () { window.location.href = l2.path; });
          }
        });
      });
    });

    // We now own all nav content — hide everything the theme injected.
    Array.from(mobileNavContent.children).forEach(function (child) {
      if (child.id === 'st1-mobile-sport' || child.id === 'st1-mobile-nav') return;
      child.style.setProperty('display', 'none', 'important');
    });
  }

  function st1BuildMobileNavFromMenu() {
    if (window.innerWidth >= 1024) return;
    if (document.getElementById('st1-mobile-sport')) return;
    var dataEl = document.getElementById('st1-sport-menu-data');
    if (!dataEl) return;
    var DATA; try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sports = (DATA && DATA.sports) || [];
    if (!sports.length) return;
    var mobileNavContent =
      document.querySelector('.main-nav-mobile .scrollbar-body') ||
      document.querySelector('.main-nav-mobile .overflow-y-auto') ||
      document.querySelector('.main-nav-mobile') ||
      document.querySelector('.mobile-menu-drawer .scrollbar-body') ||
      document.querySelector('.mobile-menu-drawer') ||
      document.querySelector('nav.main-nav-mobile');
    if (!mobileNavContent) return;
    function strip(t){ var i=t.indexOf(' – '); if(i!==-1) return t.slice(i+3).trim(); var p=t.split(' - '); return p.length>1?p[p.length-1].trim():t; }
    var wrap = document.createElement('div'); wrap.id='st1-mobile-sport'; wrap.style.borderBottom='1px solid #e5e7eb';
    var topRow=document.createElement('div'); topRow.style.cssText='display:flex;align-items:center;justify-content:space-between;padding:16px 12px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
    var topLabel=document.createElement('span'); topLabel.textContent='Shop by Sport'; topLabel.style.cssText='font-size:1rem;font-weight:700;color:#424242;font-family:Lexend,sans-serif;';
    var topChev=document.createElement('span'); topChev.textContent='›'; topChev.style.cssText='font-size:1.3rem;color:#F37321;display:inline-block;transition:transform .25s;margin-left:14px;';
    topRow.appendChild(topLabel); topRow.appendChild(topChev); wrap.appendChild(topRow);
    var sportList=document.createElement('div'); sportList.style.cssText='display:none;background:#f9f9f9;'; wrap.appendChild(sportList);
    topRow.addEventListener('click',function(){ var o=sportList.style.display==='none'; sportList.style.display=o?'block':'none'; topChev.style.transform=o?'rotate(90deg)':'none'; });
    var backRow=document.createElement('div'); backRow.style.cssText='display:none;align-items:center;padding:14px 12px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
    var backLabel=document.createElement('span'); backLabel.style.cssText='font-size:.95rem;font-weight:700;color:#F37321;font-family:Lexend,sans-serif;'; backRow.appendChild(backLabel); sportList.appendChild(backRow);
    var sportRows=[], catPanels=[];
    function showSports(){ topRow.style.display=''; backRow.style.display='none'; sportRows.forEach(function(r){r.style.display='flex';}); catPanels.forEach(function(c){c.style.display='none';}); }
    function drill(panel,name){ topRow.style.display='none'; backLabel.textContent='‹  '+name; backRow.style.display='flex'; sportRows.forEach(function(r){r.style.display='none';}); catPanels.forEach(function(c){c.style.display=(c===panel)?'block':'none';}); }
    backRow.addEventListener('click',showSports);
    sports.forEach(function(sport){
      if(!sport.title) return;
      var sportRow=document.createElement('div'); sportRow.style.cssText='display:flex;align-items:center;padding:12px 12px 12px 20px;background:#f2f2f2;border-bottom:1px solid #e5e7eb;cursor:pointer;';
      var sl=document.createElement('span'); sl.textContent=sport.title; sl.style.cssText='flex:1;color:#333;font-size:.92rem;font-weight:600;font-family:Lexend,sans-serif;'; sportRow.appendChild(sl);
      var sc=document.createElement('span'); sc.textContent='›'; sc.style.cssText='font-size:1rem;color:#999;display:inline-block;flex-shrink:0;margin-left:8px;'; sportRow.appendChild(sc);
      sportList.appendChild(sportRow);
      var catPanel=document.createElement('div'); catPanel.style.cssText='display:none;background:#fff;'; sportList.appendChild(catPanel);
      sportRows.push(sportRow); catPanels.push(catPanel);
      var cats=sport.categories||[];
      if(!cats.length){ sportRow.addEventListener('click',function(){ window.location.href=sport.url; }); return; }
      sportRow.addEventListener('click',function(){ drill(catPanel, sport.title); });
      cats.forEach(function(cat){
        var subs=cat.subs||[];
        var l2Row=document.createElement('div'); l2Row.style.cssText='display:flex;align-items:center;padding:11px 12px 11px 28px;background:#f5f5f5;border-bottom:1px solid #e5e7eb;cursor:pointer;';
        var l2l=document.createElement('span'); l2l.textContent=cat.title; l2l.style.cssText='flex:1;color:#333;font-size:.88rem;font-weight:600;font-family:Lexend,sans-serif;'; l2Row.appendChild(l2l);
        catPanel.appendChild(l2Row);
        if(!subs.length){ l2Row.addEventListener('click',function(){ window.location.href=cat.url; }); return; }
        var l2c=document.createElement('span'); l2c.textContent='›'; l2c.style.cssText='font-size:.95rem;color:#999;display:inline-block;transition:transform .2s;flex-shrink:0;margin-left:6px;'; l2Row.appendChild(l2c);
        var l3List=document.createElement('div'); l3List.style.cssText='display:none;background:#fafafa;'; catPanel.appendChild(l3List);
        subs.forEach(function(sub){ var a=document.createElement('a'); a.href=sub.url; a.textContent=strip(sub.title); a.style.cssText='display:block;padding:9px 12px 9px 44px;color:#555;font-size:.83rem;font-family:Lexend,sans-serif;text-decoration:none;border-bottom:1px solid #f0f0f0;'; l3List.appendChild(a); });
        l2Row.addEventListener('click',function(){ var o=l3List.style.display==='none'; l3List.style.display=o?'block':'none'; l2c.style.transform=o?'rotate(90deg)':'none'; l2Row.style.background=o?'#ececec':'#f5f5f5'; });
      });
    });
    mobileNavContent.insertBefore(wrap, mobileNavContent.firstChild);
    var NAV=[
      {t:'Apparel',u:'/collections/apparel',c:[['All Apparel','/collections/apparel'],["Men's",'/collections/apparel-mens'],["Women's",'/collections/apparel-womens'],['Youth','/collections/apparel-youth'],['Headwear','/collections/apparel-headwear']]},
      {t:'Footwear',u:'/collections/footwear',c:[['All Footwear','/collections/footwear'],['Baseball','/collections/footwear-baseball'],['Softball','/collections/footwear-softball'],['Volleyball','/collections/footwear-volleyball'],['Running','/collections/footwear-running'],['Training','/collections/footwear-training'],['Lifestyle','/collections/footwear-lifestyle']]},
      {t:'Eyewear',u:'/collections/eyewear',c:[['All Eyewear','/collections/eyewear'],['Baseball & Softball','/collections/eyewear-baseball-softball'],['Lifestyle','/collections/eyewear-lifestyle'],['Running & Cycling','/collections/eyewear-running-cycling'],['Snow Sports','/collections/eyewear-snow-sports']]},
      {t:'Sale',u:'/collections/sale',c:[]},
      {t:'Team Gear',u:'/pages/team-gear',c:[]},
      {t:'Custom Team Store',u:'/pages/custom-team-store',c:[]}
    ];
    var nav=document.createElement('div'); nav.id='st1-mobile-nav';
    NAV.forEach(function(item){
      var row=document.createElement('div'); row.style.cssText='display:flex;align-items:center;justify-content:space-between;padding:14px 12px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
      var lbl=document.createElement('span'); lbl.textContent=item.t; lbl.style.cssText='font-size:1rem;font-weight:700;color:#424242;font-family:Lexend,sans-serif;'; row.appendChild(lbl);
      var chev=document.createElement('span'); chev.style.cssText='font-size:1.3rem;color:#F37321;display:inline-block;transition:transform .25s;'; row.appendChild(chev); nav.appendChild(row);
      if(item.c.length){ chev.textContent='›'; var sub=document.createElement('div'); sub.style.cssText='display:none;background:#f9f9f9;';
        item.c.forEach(function(ch){ var a=document.createElement('a'); a.href=ch[1]; a.textContent=ch[0]; a.style.cssText='display:block;padding:12px 12px 12px 24px;color:#424242;font-size:.9rem;font-weight:500;font-family:Lexend,sans-serif;text-decoration:none;border-bottom:1px solid #e5e7eb;background:#fff;'; sub.appendChild(a); });
        nav.appendChild(sub);
        row.addEventListener('click',function(){ var o=sub.style.display==='none'; sub.style.display=o?'block':'none'; chev.style.transform=o?'rotate(90deg)':'none'; });
      } else { row.addEventListener('click',function(){ window.location.href=item.u; }); }
    });
    wrap.insertAdjacentElement('afterend', nav);
    Array.prototype.slice.call(mobileNavContent.children).forEach(function(child){ if(child.id==='st1-mobile-sport'||child.id==='st1-mobile-nav') return; child.style.setProperty('display','none','important'); });
  }

  // ── INIT ─────────────────────────────────────────────────────────────────
  function initDesktop() {
    document.querySelectorAll('.drawer-menu__sub-panel').forEach(function (panel) {
      initDesktopPanel(panel);
      if (!panel._st1obs) {
        panel._st1obs = new MutationObserver(function () { initDesktopPanel(panel); });
        panel._st1obs.observe(panel, { childList: true, subtree: true });
      }
    });
  }

  // Pre-fetch collection map as soon as page loads (before drawer is opened)
  getCollectionMap(function () {});

  // Desktop: watch drawer section for lazily-rendered panels
  var drawerInitTimer = null;
  function attachDrawerObs() {
    var sect = document.querySelector('.x-drawer-menu');
    if (sect && !sect._st1DrawerObs) {
      sect._st1DrawerObs = true;
      new MutationObserver(function () {
        clearTimeout(drawerInitTimer);
        drawerInitTimer = setTimeout(function () {
          initDesktop();
          initMobileNav();
        }, 150);
      }).observe(sect, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attachDrawerObs(); initDesktop(); });
  } else {
    attachDrawerObs();
    initDesktop();
  }

  document.addEventListener('shopify:section:load', function () { attachDrawerObs(); initDesktop(); initMobileNav(); });

  // Body class change fires after Alpine finishes rendering the drawer — use for mobile
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].type === 'childList') attachDrawerObs();
      // Class change = drawer opened/closed
      initMobileNav();
      initDesktop();
      break;
    }
  }).observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class'] });
})();